import { Heading, Link } from '@chakra-ui/react';

export default function ExternalNavlink(props) {
    const { text, href } = props;
    return (
        <Heading size = "sm">
            <Link href = { href } color = "teal.200" target = "_blank" textDecorationLine = "underline">{ text }</Link>
        </Heading>
    );
};